import axios from 'axios'

export default {
  /**
   *
   * Get user limits data.
   *
   * @function
   * @return response {Promise} Request response.
   */
  getLimits: () => axios.get(`/api/creative-studio/limits`),

  // TODO:  more info needed on comments, usage and params
  /**
   *
   * Upgrade.
   *
   * @function
   * @return response {Promise} Request response.
   */
  upgrade: (id, payload) => axios.post(`/api/creative-studio/upgrade`, payload),

  // TODO: more info needed on comments, usage and params
  /**
   *
   * Get user limits data.
   *
   * @param {String} params none, one or multiple query strings without values from: assets, banners, videos, templates, folders
   * @returns
   */
  getUsage: (params) => axios.get(`/api/creative-studio/usage`, { params }),
}
